import { render, staticRenderFns } from "./TableWithSelections.vue?vue&type=template&id=64c1b5ee"
import script from "./TableWithSelections.vue?vue&type=script&lang=js"
export * from "./TableWithSelections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dartanghanvani/Documents/workspace/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64c1b5ee')) {
      api.createRecord('64c1b5ee', component.options)
    } else {
      api.reload('64c1b5ee', component.options)
    }
    module.hot.accept("./TableWithSelections.vue?vue&type=template&id=64c1b5ee", function () {
      api.rerender('64c1b5ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/TableWithSelections.vue"
export default component.exports